/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState } from "react";
import { FieldArray } from "formik";
import Icon from "components/Icon";
import { GridColumnTitle } from "components/Form";
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableColumn,
  InlineLabel,
  LabelEdit
} from "./styles";
import moment from "moment";

const ImportPreview = ({ file }) => {
  const [sortBy, setSortBy] = useState({ key: null, direction: null });

  const columns = [
    {
      title: "CURRENCY",
    },
    {
      title: "CURRENCY TARGET",
    },
    {
      title: "CURRENCY RATE",
    },
    {
      title: "DATE",
    },
    {
      title: "VALUES STATUS"
    }
  ];

  return (
    <Table>
      <TableHead>
        {columns.map((column, index) => (
          <TableHeader
            key={index}
          >
          <GridColumnTitle>
            {column.title}
          </GridColumnTitle>
            { column.value &&
              sortBy.key === column.value &&
              sortBy.direction === "asc" ? (
                <Icon name={"arrowup"} />
              ) : column.value &&
                sortBy.key === column.value &&
                sortBy.direction === "desc" ? (
                <Icon name={"arrowdown"} />
              ) : ("")
            }
          </TableHeader>
        ))}
      </TableHead>
      <TableBody>
        <FieldArray name="currencies"
          render={() => (file && file.map((currency, index) => (
            <TableRow key={index} error={currency.error !== 'OK'}>
              <TableColumn>
                <InlineLabel>
                  CURRENCY
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {currency.currencyCode}
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                  CURRENCY TARGET
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  USD
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                  CURRENCY RATE
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {currency.currencyRate}
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                  DATE
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {currency.date ? moment(currency.date).format('DD/MM/YYYY') : 'Invalid date'}
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                  VALUES STATUS
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {currency.error}
                </LabelEdit>
              </TableColumn>
            </TableRow>
          )))}
        />
      </TableBody>
    </Table>
  );
};

export default ImportPreview;